import { useEffect } from 'react';
import TechItem from '../../common/TechItem';
import '../../Technology.css'

const Cnis19 = () => {

    useEffect(() => {
        document.title = 'Séneca volverá a estar presente en el CNIS 2019'
        window.scrollTo(0, 0)
    }, []);


    return (

        <TechItem
            title={"Séneca volverá a estar presente en el CNIS 2019"}
            imageURL={'/images/technology/tecnologia-2.jpg'}
            date={"20 febrero, 2019"}
            textArray={[
                "<p className='middle-section-label'>La novena edición del Congreso Nacional de Innovación y Servicios Públicos (CNIS 2019), que se celebrará en la Fábrica Nacional de Moneda y Timbre Real Casa de la Moneda los próximos días 27 y 28 de febrero,  volverá a contar con la presencia de nuestro software Séneca como una de las herramientas fundamentales para la grabación y creación de video-actas y la difusión de los plenos.</p>",
                "<p className='middle-section-label'>Tras las buenas sensaciones obtenidas en la edición del pasado año, nuestro gerente Castor Alonso, expondrá las completas características de nuestro sistema para instituciones, ayuntamientos y diputaciones. La cita será el día 27 de febrero a las 12:00 horas en el Espacio Demo III.</p>",
                "<p className='middle-section-label'>El congreso cuenta con una mediateca generada por nuestro software (cnis.seneca.tv) en la que se pueden consultar todas las grabaciones de la edición pasada, así como los oradores que participaron en ella. Una vez finalice el congreso, recogerá también las de la presente edición.</p>"
            ]}
        />

    )
}

export default Cnis19